
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";

/**
 * GroupCodeLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class GroupCodeLookupService<T = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    GetGroupCodeList(): Promise<T[]> {
        return this.$apiService.sendAuth("IGroupCodeLookupService/GetGroupCodeList");
    }
}
